import React, { useState, useEffect } from 'react';
import Header from '../../dashboard/header';
import Navbar from '../../dashboard/navbar';
import Sidebar from '../../dashboard/sidebar';
import { useLocation, useNavigate, Link } from 'react-router-dom';
import { Modal } from 'react-bootstrap'; // Importer la modal
import useAuth from '../../dashboard/useAuth';
import { FaBoxes, FaTools } from 'react-icons/fa';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import 'react-quill/dist/quill.bubble.css';
import axios from 'axios';

const Modifier_produit = ({ titre }) => {
    useAuth();
    const location = useLocation();
    const { produit_id } = location.state || {};
    const user_id = localStorage.getItem('user_id');
    const navigate = useNavigate();

    // Set page title
    useEffect(() => {
        if (user_id) {
            document.title = "eTrainApp | Modifier Produit";
        }
    }, [user_id]);

    const [produitData, setProduitData] = useState({
        nom: '',
        description: '',
        prix: '',
        periode: '',
    });
    const [originalProduitData, setOriginalProduitData] = useState({});
    const [showModal, setShowModal] = useState(false);

    useEffect(() => {
        const fetchProduitData = async () => {
            try {
                const response = await fetch(process.env.REACT_APP_HOTE + `/produit-info/${produit_id}/`);
                if (response.ok) {
                    const data = await response.json();
                    setProduitData({
                        nom: data.nom,
                        description: data.description,
                        prix: data.prix,
                        periode: data.periode,
                    });
                    setOriginalProduitData({
                        nom: data.nom,
                        description: data.description,
                        prix: data.prix,
                        periode: data.periode,
                    });
                } else {
                    console.error('Erreur lors de la récupération des données du produit');
                }
            } catch (error) {
                console.error('Erreur réseau:', error);
            }
        };

        fetchProduitData();
    }, [produit_id]);

    const handleSubmit = async (event) => {
        event.preventDefault();
        const dataToSend = {
            nom: produitData.nom,
            description: produitData.description,
            prix: produitData.prix,
            periode: produitData.periode,
        };

        try {
            const response = await fetch(process.env.REACT_APP_HOTE + `/modifier-produit/${produit_id}/`, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(dataToSend),
            });

            if (!response.ok) {
                const errorData = await response.json();
                console.error('Erreur:', errorData);
            } else {
                const data = await response.json();
                console.log('Succès:', data);
                navigate(`/Liste-produit`);
            }
        } catch (error) {
            console.error('Erreur réseau:', error);
        }
    };

    const handleShowModal = (event) => {
        event.preventDefault();
        setShowModal(true);
    };

    const handleCloseModal = () => {
        setShowModal(false);
    };

    const handleConfirmCancel = () => {
        setProduitData(originalProduitData);
        setShowModal(false);
    };

    const handleReset = () => {
        setProduitData(originalProduitData);
    };

    const modules = {
        toolbar: [
            [{ 'header': [1, 2, false] }],
            ['bold', 'italic', 'underline'],
            ['link', 'image'],
            [{ 'list': 'ordered' }, { 'list': 'bullet' }],
            ['clean'],
            [{ 'align': [] }],
        ],
    };

    const [accesGroupe, setAccesGroupe] = useState([]);
    const [groupeId, setGroupeId] = useState(null);
    const groupe = localStorage.getItem('groupe');

    const verifGroupe = async () => {
        const groupeStored = localStorage.getItem('groupe');
        const accesGroupeStored = localStorage.getItem('accesGroupe');

        if (groupeStored && accesGroupeStored) {
            setGroupeId(groupeStored);
            setAccesGroupe(JSON.parse(accesGroupeStored));
        } else {
            try {
                const response = await axios.get(`${process.env.REACT_APP_HOTE}/verif-groupe/${user_id}/${groupe}`);
                if (response.status === 200) {
                    const data = response.data;
                    setGroupeId(data.groupe);

                    let cleanedAccessArray = [];
                    if (Array.isArray(data.acces)) {
                        cleanedAccessArray = data.acces.map((item) =>
                            item.acces
                                ? item.acces.replace(/[\[\]']/g, '').trim().split(',').map((access) => access.trim())
                                : []
                        ).flat();

                        setAccesGroupe(cleanedAccessArray);
                    }

                    localStorage.setItem('groupe', data.groupe);
                    localStorage.setItem('accesGroupe', JSON.stringify(cleanedAccessArray));
                }
            } catch (error) {
                // console.error('Erreur lors de la vérification du groupe', error);
            }
        }
    };

    useEffect(() => {
        if (user_id) {
            verifGroupe();
        }
    }, [user_id]);

    if (!accesGroupe.includes("Produits")) {
        return (
            <div id="wrapper">
                <Sidebar user_id={user_id} titre={titre} />
                <div id="page-wrapper" className="gray-bg">
                    <Navbar />
                    <div className="wrapper wrapper-content animated fadeInRight">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="ibox">
                                    <div className="ibox-content text-center p-5">
                                        <div className="mb-4">
                                            <i className="fa fa-lock fa-5x text-warning"></i>
                                        </div>
                                        <h2>Accès restreint</h2>
                                        <p className="lead mb-4">
                                            Vous n'avez pas les autorisations nécessaires pour accéder à cette page.
                                        </p>
                                        <div className="d-flex justify-content-center">
                                                                                    <Link to="/" className="btn btn-primary">
                                                                                        <i className="fa fa-arrow-left mr-2"></i>
                                                                                        Retour
                                                                                    </Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div id="wrapper">
            <Sidebar user_id={user_id} titre={titre} />
            <div id="page-wrapper" className="gray-bg">
                <Navbar />
                <div>
                    <div className="row wrapper border-bottom white-bg page-heading">
                        <div className="col-lg-12">
                            <h2 className='d-flex align-items-center'><FaBoxes size={25} className='mr-2' /> Modification du produit {originalProduitData.nom}</h2>
                            <small>Administration des produits.</small>
                            <small id='hbreadcrumb' className='d-flex justify-content-end'>
                                <ol className="breadcrumb custom-breadcrumb">
                                    <li className="breadcrumb-item custom-breadcrumb-item">
                                        <Link to={`/admin`}>Administration</Link>
                                    </li>
                                    <li className="breadcrumb-item custom-breadcrumb-item">
                                        <Link to={`/Liste-produit`}>Produits</Link>
                                    </li>
                                    <li className="breadcrumb-item custom-breadcrumb-item">
                                        Modification du produit {originalProduitData.nom}
                                    </li>
                                </ol>
                            </small>
                        </div>
                    </div>

                    <div className="container-fluid mt-5"> {/* Ensure full container for responsiveness */}
                        <div className="row justify-content-center">
                            <div className="col-12 col-lg-8 mt-3 mb-3"> {/* Use breakpoints for width control */}
                                <div className="ibox-content">
                                    <div className="hpanel">
                                        <div className="panel-body">
                                            <form className="m-t" role="form" onSubmit={handleSubmit}>
                                                <div className="row">
                                                    {/* Full width on small screens, half width on medium+ screens */}
                                                    <div className="form-group col-12 col-md-12">
                                                        <label>Nom*</label>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            required
                                                            name="nom"
                                                            value={produitData.nom}
                                                            onChange={(e) => setProduitData({ ...produitData, nom: e.target.value })}
                                                        />
                                                    </div>
                                                    <div className="form-group col-12 col-md-12">
                                                        <label>Description*</label>
                                                        <ReactQuill
                                                            theme="snow"
                                                            value={produitData.description}
                                                            onChange={(value) => setProduitData({ ...produitData, description: value })}
                                                            modules={modules}
                                                        />
                                                    </div>
                                                    <div className="form-group col-12 col-md-12">
                                                        <label>Prix*</label>
                                                        <input
                                                            type="number"
                                                            className="form-control"
                                                            value={produitData.prix}
                                                            onChange={(e) => setProduitData({ ...produitData, prix: e.target.value })}
                                                            required
                                                            name="prix"
                                                        />
                                                    </div>
                                                    <div className="form-group col-12 col-md-12">
                                                        <label>Période*</label>
                                                        <select
                                                            className="form-control"
                                                            name="periode" value={produitData.periode}
                                                            onChange={(e) => setProduitData({ ...produitData, periode: e.target.value })}
                                                            required
                                                        >
                                                            <option value="">Sélectionner une période</option>
                                                            {[...Array(12)].map((_, index) => {
                                                                const mois = index + 1;
                                                                const heures = mois * 730;
                                                                return (
                                                                    <option key={mois} value={heures}>
                                                                        {mois} {mois === 1 ? "mois" : "mois"} ({heures} heures)
                                                                    </option>
                                                                );
                                                            })}
                                                        </select>
                                                    </div>
                                                </div>
                                                <div className="text-center mt-5">
                                                    <a href='/Liste-produit' className="btn btn-default mr-2">Annuler</a>
                                                    <button type="button" className="btn btn-default mr-2" onClick={handleReset}>Effacer</button>
                                                    <button type="submit" className="btn btn-success">Enregistrer</button>
                                                </div>
                                            </form>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>

            {/* Modal de confirmation */}
            <Modal show={showModal} onHide={handleCloseModal}>
                <Modal.Header>
                    <Modal.Title>Confirmation</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    Êtes-vous sûr de vouloir annuler les modifications ?
                </Modal.Body>
                <Modal.Footer>
                    <button className="btn btn-secondary" onClick={handleCloseModal}>Non</button>
                    <button className="btn btn-success" onClick={handleConfirmCancel}>Oui</button>
                </Modal.Footer>
            </Modal>
        </div>
    );
};

export default Modifier_produit;
